//PrimeReact
import { InputText } from "primereact/inputtext"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import { useEffect, useState } from "react"
import FormulaBuilderQuestionOrderEntry from "./FormulaBuilderQuestionOrderEntry"
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"
import { classNames } from "primereact/utils"
import elementTypes from "../Elements/elementTypes"

export default function FormulaBuilderQuestions({ questionOptions }) {
  const [searchText, setSearchText] = useState("")
  const [filteredOptions, setFilteredOptions] = useState(questionOptions)
  const searchTextLower = searchText.toLowerCase()

  useEffect(() => {
    let newFilteredOptions = questionOptions.filter(
      (option) => !option.isDeleted,
    )

    if (searchText !== "") {
      const searchLower = searchText.toLowerCase()
      const newFilteredOptions = questionOptions?.filter((option) => {
        if (
          option.question &&
          elementTypes.isMatrixType(option.question?.type) &&
          option.question.questionLabels
        ) {
          return option.question.questionLabels
            .filter((label) => !label.isDeleted) //Ignore deleted labels
            .some((label) => label.text.toLowerCase().includes(searchLower)) //Check if any label matches search
        } else if (option.question) {
          return option.question?.text?.toLowerCase().includes(searchLower)
        } else {
          return option.questionGroup?.text?.toLowerCase().includes(searchLower)
        }
      })

      setFilteredOptions(newFilteredOptions ?? [])
    } else {
      setFilteredOptions(newFilteredOptions)
    }
  }, [searchText, questionOptions])

  return (
    <>
      <div
        className={classNames(
          myStyles.questionsStickyContainer,
          myStyles.groupingContainer,
        )}
      >
        <FormulaBuilderGroupingPanel title="Questions">
          Choose a question and drag it onto the form to add its score to the
          formula.
        </FormulaBuilderGroupingPanel>
        <div
          className={classNames(myStyles.container, myStyles.searchContainer)}
        >
          <span
            className="p-input-icon-left"
            style={{ flexGrow: "2", border: "none", width: "100%" }}
          >
            <i className="pi pi-search " />
            <InputText
              value={searchText}
              placeholder="Search"
              style={{ width: "100%", border: "none" }}
              onChange={(e) => {
                setSearchText(e.target.value)
              }}
            />
          </span>
        </div>
      </div>
      <div
        className={classNames(
          myStyles.groupingContainer,
          myStyles.questionListContainer,
        )}
      >
        {filteredOptions && filteredOptions.length > 0 ? (
          filteredOptions.flatMap((option) => {
            if (
              elementTypes.isMatrixType(option.question?.type) &&
              option.question?.questionLabels
            ) {
              return option.question.questionLabels
                .filter(
                  (questionLabel) =>
                    !questionLabel.isDeleted &&
                    (searchText === "" ||
                      questionLabel.text
                        .toLowerCase()
                        .includes(searchTextLower)),
                )
                .map((questionLabel) => (
                  <FormulaBuilderQuestionOrderEntry
                    key={questionLabel.id}
                    entry={{
                      ...option,
                      id: questionLabel.id,
                      question: {
                        ...option.question,
                        id: questionLabel.id,
                        text: `${option.question.text}: ${questionLabel.text}`,
                      },
                    }}
                  />
                ))
            } else {
              return (
                <FormulaBuilderQuestionOrderEntry
                  key={option.id}
                  entry={option}
                />
              )
            }
          })
        ) : (
          <>No form entities found</>
        )}
      </div>
    </>
  )
}
